import { uniqueId } from "lodash";
import create from "zustand";
import { ELEMENTS } from "../../utils";

export const initialState = {
  [ELEMENTS.CHECK_QUALIFY]: "",
  [ELEMENTS.LOWER_PRICE_RETAILER]: "",
  [ELEMENTS.PURCHASED_FROM]: "",
  [ELEMENTS.PURCHASED_SHOP]: "",
  [ELEMENTS.PURCHASED_PAYMENT_MODE]: "",
  [ELEMENTS.PURCHASED_DATE]: "",
  [ELEMENTS.RECEIPT_PHOTOS]: {
    attachments: [],
    attachmentError: null,
  },
  [ELEMENTS.ORDER_NUMBER]: "",
  [ELEMENTS.JL_PRODUCT_CODE]: "",
  [ELEMENTS.PRODUCT_NAME]: "",
  [ELEMENTS.PRODUCT_COLOR]: "",
  [ELEMENTS.PRICE_PAID_AT_JL]: "",
  [ELEMENTS.PRICE_TO_MATCH]: "",
  [ELEMENTS.LINK_TO_LOWER_PRICES]: "",
  [ELEMENTS.LOWER_PRICE_PHOTOS]: {
    attachments: [],
    attachmentError: null,
  },
  [ELEMENTS.USER_TITLE]: "",
  [ELEMENTS.FIRST_NAME]: "",
  [ELEMENTS.LAST_NAME]: "",
  [ELEMENTS.PHONE]: "",
  [ELEMENTS.EMAIL]: "",
  [ELEMENTS.POSTCODE]: "",
};

export const useFormStore = create(set => ({
  ...initialState,
  // Actions
  updateResponses: payload =>
    set(state => ({
      ...state,
      ...payload,
    })),

  addAttachment: ({ name: key, ...attachment }) =>
    set(state => ({
      [key]: {
        ...state[key],
        attachments: [...state[key].attachments, { ...attachment, fileId: uniqueId() }],
        attachmentError: null,
      },
    })),

  removeAttachment: ({ name: key, fileId }) =>
    set(state => {
      return {
        [key]: {
          ...state[key],
          attachments: state[key].attachments.filter(attachment => attachment.fileId !== fileId),
          attachmentError: null,
        },
      };
    }),

  setAttachmentError: ({ name: key, error }) =>
    set(state => ({
      [key]: {
        ...state[key],
        attachmentError: error,
      },
    })),
  reset: () => set(initialState),
}));
